import gql from 'graphql-tag';
import {
  AccountFields,
  OptInFormFields,
  SmartLinkFields,
  AvailableServiceFields,
  SegmentationQuestionFields,
  AvailableEventFields,
} from './fragments';

export const GET_EVENT_USER = gql`
  query registration($registrationId: ID!) {
    node(id: $registrationId) {
      ... on EventRegistration {
        id
        status
        attendee {
          firstName
          lastName
          primaryPhoneNumber {
            number
          }
        }
        event {
          title
          virtualPhoneNumber {
            phoneNumber
            account {
              name
            }
          }
        }
      }
    }
  }
`;

export const GET_EVENTS_LIST = gql`
  query availableEventList($vpn: String!) {
    getVpn(phoneNumber: $vpn) {
      friendlyName
      id
      phoneNumber
      account {
        ...AccountFields
      }
      availableEvents {
        ...AvailableEventFields

        coverMedia {
          image {
            sourceUuid
            extensionType
            uri
          }
          video {
            sourceUuid
            extensionType
            uri
          }
        }
        location {
          type
          virtualLocation
          venue {
            name
            address
            city
            state
            zipCode
          }
        }
        date {
          timeZone
          startDate
          endDate
          startTime
          endTime
        }
        representationalMetadataList {
          type
          destination
          content
        }
      }
    }
  }
  ${AvailableEventFields}
  ${AccountFields}
`;

export const GET_EVENT_ITEM = gql`
  query availableEventList($vpn: String!, $eventId: ID) {
    getVpn(phoneNumber: $vpn) {
      id
      friendlyName
      phoneNumber
      account {
        ...AccountFields
      }
      availableEvents(eventId: $eventId) {
        ...AvailableEventFields

        coverMedia {
          image {
            sourceUuid
            extensionType
            uri
          }
          video {
            sourceUuid
            extensionType
            uri
          }
        }
        location {
          type
          virtualLocation
          venue {
            name
            address
            city
            state
            zipCode
          }
        }
        date {
          timeZone
          startDate
          endDate
          startTime
          endTime
        }
        representationalMetadataList {
          type
          destination
          content
        }
      }
    }
  }
  ${AvailableEventFields}
  ${AccountFields}
`;

export const GET_OPT_IN_FORM = gql`
  query optInForm($vpn: String!) {
    optInForm(vpn: $vpn) {
      ...OptInFormFields
      account {
        ...AccountFields
      }
      questions {
        ...SegmentationQuestionFields
      }
      optionalFields {
        lastName {
          isVisible
          isRequired
        }
        zipCode {
          isVisible
          isRequired
        }
      }
    }
  }
  ${AccountFields},
  ${OptInFormFields},
  ${SegmentationQuestionFields}
`;

export const GET_SNAPFLOW_LINKS = gql`
  query getAccount($vpn: String!) {
    getAccount(vpn: $vpn) {
      ...AccountFields,

      smartLinks {
        ...SmartLinkFields
      }
    }
  }
  ${AccountFields},
  ${SmartLinkFields}
`;

export const GET_SERVICE_LIST = gql`
  query availableServiceList($vpn: String!) {
    getVpn(phoneNumber: $vpn) {
      friendlyName
      id
      phoneNumber
      account {
        ...AccountFields
      }
      bookingLandingPage {
        avatarMedia {
          extensionType
          sourceUuid
          uri
        }
        guestFormInstr
        serviceListInstr
        subtitle
        intervalListInstr
        title
      }
      availableServices {
        ...AvailableServiceFields
      }
    }
  }
  ${AccountFields},
  ${AvailableServiceFields}
`;

export const GET_SERVICE_TIMESLOTS = gql`
  query availableTimeSlots($month: Int!, $year: Int!, $serviceId: ID!) {
    availableTimeSlots(month: $month, year: $year, serviceId: $serviceId) {
      edges {
        day
        timeSlots
      }
      pageInfo {
        firstMonth {
          month
          year
        }
        lastMonth {
          month
          year
        }
      }
    }
  }
`;
